// The card under a bill of materials and routing LAMP drafted from the person's words (#565): Confirm records it as
// drafted; Correct opens the part's Form, filled in from the draft, and confirms it as corrected. Once recorded, the
// card says so and offers nothing more.
import { useState } from "react";
import type { BomDraftCard, PartBomGiven } from "../api.js";
import { useWords } from "../i18n/words.js";
import { PartBomForm } from "../items/PartBomForm.js";

export function BomDraftCardView({
  card,
  busy,
  onConfirm,
}: {
  card: BomDraftCard;
  busy: boolean;
  /** Confirms the draft, as corrected when given; throws the API's refusal. */
  onConfirm: (given?: PartBomGiven) => Promise<void>;
}) {
  const w = useWords();
  const [correcting, setCorrecting] = useState(false);
  if (card.status === "done") return <p className="small muted">{w.masterRecorded}</p>;
  return (
    <div className="card">
      {correcting ? (
        <PartBomForm
          form={card.form}
          submitLabel={w.masterConfirm}
          busy={busy}
          onSubmit={(given) => void onConfirm(given).catch(() => undefined)}
        />
      ) : (
        <div className="actions">
          <button type="button" className="btn" disabled={busy} onClick={() => void onConfirm().catch(() => undefined)}>
            {w.masterConfirm}
          </button>
          <button type="button" className="btn" disabled={busy} onClick={() => setCorrecting(true)}>
            {w.masterCorrect}
          </button>
        </div>
      )}
    </div>
  );
}
